// extracted by css-extract-rspack-plugin
export default {"button":"qw4fL","icon":"FyoUZ"};